import { RehearsalSceneItemRequestDTO } from './RehearsalSceneItemRequestDTO';

export class RehearsalSceneRequestDto {
    public id: number = 0;
    public items: RehearsalSceneItemRequestDTO[] = [];
    public required: boolean = false;
    public notes: string = '';
    public orderIndex: number = 0;
}
